/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscribeDto
 */
export interface SubscribeDto {
    /**
     * 
     * @type {string}
     * @memberof SubscribeDto
     */
    authTenantId: string;
    /**
     * 
     * @type {string}
     * @memberof SubscribeDto
     */
    planName: string;
    /**
     * 
     * @type {number}
     * @memberof SubscribeDto
     */
    quantity: number;
    /**
     * 
     * @type {string}
     * @memberof SubscribeDto
     */
    successUrl: string;
    /**
     * 
     * @type {string}
     * @memberof SubscribeDto
     */
    cancelUrl: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscribeDto
     */
    isTrial: boolean;
}

/**
 * Check if a given object implements the SubscribeDto interface.
 */
export function instanceOfSubscribeDto(value: object): value is SubscribeDto {
    if (!('authTenantId' in value) || value['authTenantId'] === undefined) return false;
    if (!('planName' in value) || value['planName'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('successUrl' in value) || value['successUrl'] === undefined) return false;
    if (!('cancelUrl' in value) || value['cancelUrl'] === undefined) return false;
    if (!('isTrial' in value) || value['isTrial'] === undefined) return false;
    return true;
}

export function SubscribeDtoFromJSON(json: any): SubscribeDto {
    return SubscribeDtoFromJSONTyped(json, false);
}

export function SubscribeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscribeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'authTenantId': json['authTenantId'],
        'planName': json['planName'],
        'quantity': json['quantity'],
        'successUrl': json['successUrl'],
        'cancelUrl': json['cancelUrl'],
        'isTrial': json['isTrial'],
    };
}

export function SubscribeDtoToJSON(json: any): SubscribeDto {
    return SubscribeDtoToJSONTyped(json, false);
}

export function SubscribeDtoToJSONTyped(value?: SubscribeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'authTenantId': value['authTenantId'],
        'planName': value['planName'],
        'quantity': value['quantity'],
        'successUrl': value['successUrl'],
        'cancelUrl': value['cancelUrl'],
        'isTrial': value['isTrial'],
    };
}

